<template>
    <my-dialog title="创建销售订单提成" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
        @close="closeDialog" width="80%">
        <detail ref="detail"></detail>
        <div class="item_info">
            <el-descriptions class="margin-top" title="提成信息" :column="5" border>
                <el-descriptions-item span="3">
                    <template slot="label">
                        <i class="el-icon-user"></i>
                        销售提成员工
                    </template>
                    <el-select name="employeeKeyIds" v-model="commissionInfo.employeeKeyIds" multiple
                        placeholder="请选择员工" style="width: 100%;" filterable clearable>
                        <el-option v-for="item in employeeList" :key="item.keyId" :label="item.value"
                            :value="item.keyId" />
                    </el-select>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-cherry"></i>
                        是否电话提成
                    </template>
                    {{ salesOrderInfo.phonePnvitation ? "有" : "无" }}
                </el-descriptions-item>
                <el-descriptions-item v-if="commissionInfo.isPhoneBonus">
                    <template slot="label">
                        <i class="el-icon-user"></i>
                        电话提成员工
                    </template>
                    {{ salesOrderInfo.phonePnvitationName ? salesOrderInfo.phonePnvitationName : "无" }}
                </el-descriptions-item>
            </el-descriptions>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog">关闭</el-button>
            <el-button size="small" type="primary" @click="handleCreateSalesOrderCommission">创建销售订单提成</el-button>
        </div>
    </my-dialog>
</template>
<script>
import {
    CreateSalesOrderCommission,
    GetSalesOrderDetail
} from "@/api/productApi.js";
import detail from "@/views/product/sales/detail.vue";
import {
    GetUserBindSelectByPermission
} from "@/api/userApi.js";
export default {
    props: [],
    data() {
        return {
            showDialog: false,
            commissionInfo: {
                keyId: "",
                employeeKeyIds: [],
                isPhoneBonus: false,
                phoneEmlpoyeeKeyId: "",
            },
            storeKeyId: "",
            employeeList: [],
            phoneEmployeeList: [],
            salesOrderInfo:{}
        };
    },
    components: {
        detail,
    },
    created() { },
    methods: {
        // 显示
        getCreateCommissionDialog(row) {
            this.showDialog = true;
            this.$nextTick(() => {
                this.$refs.detail.getDetail(row);
            });
            this.storeKeyId = row.storeKeyId;
            this.commissionInfo.keyId = row.keyId;
            // 获取员工列表
            this.getEmployeeList();
            // 获取销售订单详情
            this.getSalesOrderDetail();
        },
        // 关闭
        closeDialog() {
            this.commissionInfo.isPhoneBonus = false;
            this.commissionInfo.phoneEmlpoyeeKeyId = "";
            this.commissionInfo.employeeKeyIds = [];
            this.showDialog = false;
        },
        // 确认创建销售订单提成
        handleCreateSalesOrderCommission() {
            if (this.commissionInfo.employeeKeyIds == null || this.commissionInfo.employeeKeyIds == undefined || this.commissionInfo.employeeKeyIds.length == 0) {
                this.$message({
                    type: "error",
                    message: "请选择充卡提成员工！",
                });
                return;
            }
            if (this.commissionInfo.isPhoneBonus) {
                if (this.commissionInfo.phoneEmlpoyeeKeyId == "" || this.commissionInfo.phoneEmlpoyeeKeyId == null || this.commissionInfo.phoneEmlpoyeeKeyId == undefined) {
                    this.$message({
                        type: "error",
                        message: "请选择电话提成员工！",
                    });
                    return;
                }
            }
            this.$confirm('确定创建销售订单提成吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                CreateSalesOrderCommission(this.commissionInfo)
                    .then((res) => {
                        if (res.code == 1) {
                            this.$message({
                                type: "success",
                                message: "创建销售订单提成成功！",
                            });
                            setTimeout(() => {
                                this.$parent.getListData();
                                this.showDialog = false;
                            }, 1500);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                    .catch((err) => {
                        this.$message.error("创建销售订单提成失败，请稍后再试！");
                    });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消创建销售订单提成",
                });
            });
        },
        // 获取员工列表
        getEmployeeList() {
            GetUserBindSelectByPermission({
                keyId: this.storeKeyId,
                isChargePerson: true,
            }).then((res) => {
                if (res.code == 1) {
                    this.employeeList = res.data;
                    this.phoneEmployeeList = res.data;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });
        },
        // 获取销售订单详情
        getSalesOrderDetail(){
            GetSalesOrderDetail({
                keyId: this.commissionInfo.keyId,
            }).then((res) => {
                if (res.code == 1) {
                    this.salesOrderInfo = res.data;
                    if (this.salesOrderInfo.phonePnvitation) {
                        this.commissionInfo.isPhoneBonus = true;
                        this.commissionInfo.phoneEmlpoyeeKeyId = this.salesOrderInfo.phonePnvitation;
                    }
                    else {
                        this.commissionInfo.isPhoneBonus = false;
                        this.commissionInfo.phoneEmlpoyeeKeyId = "";
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });
        },
    },
};
</script>
<style scoped lang="scss">
.main_bg {
    padding: 10px;
    margin-top: -15px;
}

.item_info {
    border-left: 5px solid #55aaff;
    padding: 5px 10px;
    border-radius: 5px;
    margin-bottom: 15px;
    border-bottom: 2px solid #e9e7e7;
}

.border_Warningcolor {
    border-left: 5px solid #ff9900;
}

.border_Green {
    border-left: 5px solid #00cc66;
}

.border_Danger {
    border-left: 5px solid #ff0000;
}

.item_title {
    display: flex;
    width: 100%;
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 10px;
    justify-content: space-between;

    .title {
        display: inline-block;
        unicode-bidi: isolate;
    }

    .btnDiv {
        display: block;
        unicode-bidi: isolate;
        word-break: break-all;
    }

    .btnDivItem {
        display: inline-block;
    }

    .text-red {
        display: block;
        background-color: #ff0000;
    }
}
</style>